import waterEngineApi from '@/api/config/waterEngineApi'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'
import { toast } from 'react-hot-toast'

function useGetDetailWaterEngine(interfaceId: number, options = {}) {
  return useQuery({
    queryKey: [queryKeys.getWaterEngine],
    queryFn: async () => {
      const { data } = await waterEngineApi.getDetail(interfaceId)

      if (!data) return null
      return data
    },
    onError: (error: any) => {
      toast.error(error.response?.data.Message)
    },
    ...options,
  })
}

export default useGetDetailWaterEngine
